import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#FCE300',
    secondary: '#FCE300',
    accent: '#e32219',
    error: '#cb0008',
    warning: '#d87600',
    info: '#458b00',
    success: '#458b00',
    white: '#ffffff',
    blue: '#2e4278',
  }
})
